const PeityChartsPlugin = {
    init: ($) => {
        $('[data-plugin="peity-pie"]').each(function () {
            const colors = $(this).attr('data-colors') ? $(this).attr('data-colors').split(',') : [];
            const width = $(this).attr('data-width') ? $(this).attr('data-width') : 20; //default is 20
            const height = $(this).attr('data-height') ? $(this).attr('data-height') : 20; //default is 20
            $(this).peity('pie', {
                fill: colors,
                width: width,
                height: height,
            });
        });
        //donut
        $('[data-plugin="peity-donut"]').each(function () {
            const colors = $(this).attr('data-colors') ? $(this).attr('data-colors').split(',') : [];
            const width = $(this).attr('data-width') ? $(this).attr('data-width') : 20; //default is 20
            const height = $(this).attr('data-height') ? $(this).attr('data-height') : 20; //default is 20
            $(this).peity('donut', {
                fill: colors,
                width: width,
                height: height,
            });
        });

        $('[data-plugin="peity-donut-alt"]').each(function () {
            $(this).peity('donut');
        });

        // line
        $('[data-plugin="peity-line"]').each(function () {
            $(this).peity('line', $(this).data());
        });

        // bar
        $('[data-plugin="peity-bar"]').each(function () {
            const colors = $(this).attr('data-colors') ? $(this).attr('data-colors').split(',') : [];
            const width = $(this).attr('data-width') ? $(this).attr('data-width') : 20; //default is 20
            const height = $(this).attr('data-height') ? $(this).attr('data-height') : 20; //default is 20
            $(this).peity('bar', {
                fill: colors,
                width: width,
                height: height,
            });
        });
    },
};

export default PeityChartsPlugin;
